import { render, staticRenderFns } from "./LanguageListAddNew.vue?vue&type=template&id=00dc685a&"
import script from "./LanguageListAddNew.vue?vue&type=script&lang=js&"
export * from "./LanguageListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./LanguageListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports